import { useState } from "react";
import { CommerceDialog, CommerceTabs, CommercePanel } from "../../commerce/CommerceDialog";
import { toast } from "../../../hooks/useToast";

/* Detalhes do provedor conectado: conta, permissões, segurança e (Mercado
   Pago) a chave "usar na loja e nos pedidos", que salva sozinha. Desconectar
   fica no rodapé, discreto, e pede uma segunda confirmação. */

export function GerenciarGateway({ gw, status, estado, cfg, salvarCfg, onReconectar, onClose, avisoPixManual = "A loja e os pedidos voltam a usar a chave PIX manual, se ela estiver ativa." }) {
  const [modo, setModo] = useState("ver");
  const [ocupado, setOcupado] = useState(false);
  const conta = gw.conta(status);
  const reconectar = estado === "reconectar";
  const cor = { "--gw-cor": gw.cor, "--b-cor": gw.cor };

  async function desconectar() {
    setOcupado(true);
    try {
      const r = await gw.desconectar();
      toast(r?.revogado === false
        ? `${gw.nome} desconectado. Não foi possível revogar a autorização agora: remova o Print Control das aplicações autorizadas no ${gw.nome}.`
        : `${gw.nome} desconectado.`, r?.revogado === false ? "info" : "success", r?.revogado === false ? 8000 : 3500);
      onClose();
    } catch (e) {
      toast(gw.mensagemErro(e), "error");
      setOcupado(false);
    }
  }

  if (modo === "confirmar") {
    return (
      <CommerceDialog className="pgw-dialogo" title={`Desconectar ${gw.nome}?`} subtitle={conta || undefined} onClose={() => !ocupado && setModo("ver")}
        footer={<>
          <button type="button" className="pgw-btn" onClick={() => setModo("ver")} disabled={ocupado}>Voltar</button>
          <button type="button" className="pgw-btn perigo primario" onClick={desconectar} disabled={ocupado}>
            {ocupado ? <><span className="pgw-spin" aria-hidden="true" /> Desconectando…</> : `Desconectar ${gw.nome}`}
          </button>
        </>}>
        <div className="pgw-etapa">
          <p>As credenciais guardadas são apagadas e as novas cobranças online deixam de funcionar até você conectar um provedor de novo.</p>
          {gw.id === "mercadopago" && <p>{avisoPixManual}</p>}
          <p>{gw.notaDesconectar}</p>
        </div>
      </CommerceDialog>
    );
  }

  const mpAtivo = cfg?.mercadoPagoAtivo !== false;
  return (
    <CommerceDialog className="pgw-dialogo" title={gw.nome}
      subtitle={reconectar ? "Reconexão necessária" : `Conectado${conta ? ` · ${conta}` : ""}`} onClose={onClose}
      footer={<>
        <button type="button" className="pgw-btn texto perigo commerce-secondary" onClick={() => setModo("confirmar")}>{gw.pedeTag ? "Desativar" : "Desconectar"}</button>
        {(reconectar || !gw.pedeTag) && (
          <button type="button" className={`pgw-btn ${reconectar ? "primario" : ""}`} style={cor} onClick={onReconectar}>
            {reconectar ? "Reconectar" : "Trocar de conta"}
          </button>
        )}
        <button type="button" className="pgw-btn" onClick={onClose}>Fechar</button>
      </>}>
      <div className="pgw-etapa" style={cor}>
        {reconectar && <div className="pgw-destaque">A autorização {gw.artigo === "a" ? "da" : "do"} {gw.nome} não vale mais. Reconecte para voltar a receber online.</div>}
        {status?.revogacaoPendente && <div className="pgw-destaque">Não foi possível revogar a autorização anterior no {gw.nome}. Remova o Print Control das aplicações autorizadas na sua conta.</div>}
        {gw.id === "mercadopago" && !reconectar && salvarCfg && (
          <div className="pgw-opcao">
            <div>
              <strong id="pgw-uso-mp">Receber pelo Mercado Pago</strong>
              <small>Na loja online e no “Receber pagamento” dos pedidos. Desligado, volta a chave PIX manual.</small>
            </div>
            <button type="button" role="switch" className="pgw-switch" aria-checked={mpAtivo} aria-labelledby="pgw-uso-mp"
              onClick={() => salvarCfg({ mercadoPagoAtivo: !mpAtivo })} />
          </div>
        )}
        <CommerceTabs>
          <CommercePanel key="conta" label="Conta">
            <div className="pgw-linhas">
              {gw.linhasConta(status).map(([rotulo, valor]) => <div key={rotulo}><span>{rotulo}</span><strong>{valor}</strong></div>)}
            </div>
          </CommercePanel>
          <CommercePanel key="permissoes" label="Permissões">
            <ul className="pgw-lista-simples">{gw.permissoes(status).map(p => <li key={p}>{p}</li>)}</ul>
          </CommercePanel>
          <CommercePanel key="seguranca" label="Segurança">
            <ul className="pgw-lista-simples">{gw.seguranca.map(s => <li key={s}>{s}</li>)}</ul>
          </CommercePanel>
        </CommerceTabs>
      </div>
    </CommerceDialog>
  );
}
